"use strict";

angular.module('swarmEnv', [])

.constant('version', '0.7.0')

.constant('env', {name:'prod',isDebugEnabled:false,isDebugLogged:false,httpsAllowInsecure:false,showSkipped:false,spreadsheetKey:'v0.7.1',saveId:'v0.2',dropboxAppKey:'834cau1gsculq4q',isDropboxEnabled:true,saveServerUrl:'https://api.swarmsim.com',isKongregateSyncEnabled:true,autopushIntervalMs:900000,googleApiKey:'AIzaSyCKodSXhv09Azbu580One8U-0TUQGkTp6c',isAppcacheEnabled:false,sentryDSN:'https://24c3eeb81d4844c5916554339b9809ff@app.getsentry.com/54547',sentrySampleRate:1,isServerBackendEnabled:false,isServerFrontendEnabled:false,gaTrackingID:'UA-66677344-1'})

;